// extracted by mini-css-extract-plugin
export default {"popup":"RBFUJ51lXj_IlB17DjYM","list":"NWxVKKbOUMorLUm0kU6g","item":"Exwyj8NGQQKFGnsHvfBw","mergeTagOptionText":"_AQhJ5KQR46QlG7ATNQz"};